<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-2">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="mb-2 text-primary">مشتریان</h3>
                <div class="mb-2">
                    <b-button v-if="accessHandling('employee', 'customers_bulk_create')"
                        @click="showModalCreateCustomer" variant="primary" class="px-2 mr-1">
                        <feather-icon size="16" icon="UsersIcon" class="mr-50" />
                        <span>ایجاد گروهی</span>
                    </b-button>
                    <b-button @click="$bvModal.show('create-customer')" variant="primary" class="px-2">
                        <feather-icon size="16" icon="UserIcon" class="mr-50" />
                        <span>ایجاد</span>
                    </b-button>
                </div>
            </div>
            <b-row>
                <b-col md="3" class="mt-25">
                    <b-form-group label="نام - نام خانوادگی - شماره اشتراک" label-for="searchTermId">
                        <b-form-input @keyup.enter="getCustomers" v-model="parameters.searchTerm" id="searchTermId"
                            autocomplete="off" class="text-center" name="searchTermId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-25">
                    <b-form-group label="شماره همراه" label-for="phoneNumberId">
                        <b-form-input dir="ltr" type="number" @keyup.enter="getCustomers"
                            v-model="parameters.phoneNumber" id="phoneNumberId" autocomplete="off" class="text-center"
                            name="phoneNumberId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="شماره سطح" label-for="levelNumberId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.levelNumber" id="levelNumberId"
                            @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="levelNumberId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="از امتیاز" label-for="startScoreId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.minScore" id="startScoreId"
                            @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="startScoreId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="تا امتیاز" label-for="endScoreId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.maxScore" id="endScoreId"
                            @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="endScoreId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="از تعداد خرید" label-for="minTotalOrdersCountId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.minTotalOrdersCount"
                            @keyup.enter="getCustomers" id="minTotalOrdersCountId" autocomplete="off"
                            class="text-center" name="minTotalOrdersCountId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="تا تعداد خرید" label-for="maxTotalOrdersCountId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.maxTotalOrdersCount"
                            @keyup.enter="getCustomers" id="maxTotalOrdersCountId" autocomplete="off"
                            class="text-center" name="maxTotalOrdersCountId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="از آخرین خرید (روز)" label-for="minDaysNumberSinceLastOrderedId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.minDaysNumberSinceLastOrdered"
                            @keyup.enter="getCustomers" id="minDaysNumberSinceLastOrderedId" autocomplete="off"
                            class="text-center" name="minDaysNumberSinceLastOrderedId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="تا آخرین خرید (روز)" label-for="maxDaysNumberSinceLastOrderedId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.maxDaysNumberSinceLastOrdered"
                            @keyup.enter="getCustomers" id="maxDaysNumberSinceLastOrderedId" autocomplete="off"
                            class="text-center" name="maxDaysNumberSinceLastOrderedId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="از مبلغ خرید" label-for="minTotalOrdersAmountId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.minTotalOrdersAmount"
                            @keyup.enter="getCustomers" id="minTotalOrdersAmountId" autocomplete="off"
                            class="text-center" name="minTotalOrdersAmountId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="2" class="mt-25">
                    <b-form-group label="تا مبلغ خرید" label-for="maxTotalOrdersAmountId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.maxTotalOrdersAmount"
                            @keyup.enter="getCustomers" id="maxTotalOrdersAmountId" autocomplete="off"
                            class="text-center" name="maxTotalOrdersAmountId" />
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="3" class="mt-25">
                    <b-form-group label="وفاداری" label-for="groupId">
                        <v-select v-model="parameters.groupId" :searchable="false" dir="rtl" :options="groupIdData"
                            :reduce="(value) => value.id" label="name" id="groupId" class="bg-white"
                            style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="3" class="mt-25">
                    <b-form-group label="محصول مورد علاقه" label-for="favoriteProductId">
                        <v-select v-model="parameters.favoriteProductId" dir="rtl" :options="products"
                            :reduce="(value) => value.id" label="name_Fa" id="favoriteProductId" class="bg-white"
                            style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="3" class="mt-25">
                    <b-form-group label="نوع ترتیب نمایش" label-for="sortById">
                        <v-select v-model="parameters.sortBy" :searchable="false" dir="rtl" :options="sortByData"
                            :reduce="(value) => value.id" label="name" id="sortById" class="bg-white"
                            style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="3" class="mt-25">
                    <b-form-group label="ترتیب نمایش" label-for="sortDescendingId">
                        <v-select v-model="parameters.sortDescending" :searchable="false" dir="rtl"
                            id="sortDescendingId" :options="sortDescendingData" :reduce="(value) => value.id"
                            label="name" class="bg-white" style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3"
                    :class="accessHandling('employee', 'customers_bulk_create') ? 'mt-75 mt-md-25' : 'mt-md-2 mt-50'">
                    <b-button @click="removeFilters" variant="secondary"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100" :disabled="loading">
                        <span>حذف فیلتر ها</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
                <b-col md="3" :class="accessHandling('employee', 'customers_bulk_create') ? 'mt-2 mt-md-25' : 'mt-2'">
                    <b-button variant="info" @click="getCustomers" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>اعمال فیلتر</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
                <b-col v-if="accessHandling('employee', 'customers_bulk_create')" md="6" class="mt-2 mt-md-25">
                    <div class="d-flex align-items-center justify-content-between border border-info rounded px-1"
                        style="height: 41px;">
                        <div class="d-flex align-items-center">
                            <feather-icon size="18" icon="UsersIcon" class="mr-50" />
                            <h5 class="mb-0">مشتریان یافت‌شده</h5>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="d-flex align-items-center mb-0 mr-50">
                                <h3 v-if="!loading" class="font-weight-bolder mb-0">{{ parameters.totalCount }}</h3>
                                <b-spinner v-else small></b-spinner>
                            </div>
                            <span>مشتری</span>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-card class="p-0 mt-2" no-body>
                <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table v-if="customerList.length" responsive :items="customerList" :fields="fields" class="mb-0"
                        striped>
                        <template #cell(customerEdit)="data">
                            <feather-icon @click="showModalEdit(data.item)" size="18" icon="EditIcon" class="pointer"
                                color="#8d88a3" />
                        </template>
                        <template #cell(ordersList)="data">
                            <router-link :to="`/customers/orders-list?id=${data.item.id}`">
                                <feather-icon icon="ArrowLeftIcon" size="19" />
                            </router-link>
                        </template>
                        <template #cell(walletBalance)="data">
                            {{ data.item.walletBalance.toLocaleString('fa-IR') }}
                        </template>
                        <template #cell(groupId)="data">
                            <div :style="{ color: customer_group_color(data.item.groupId) }">
                                {{ customer_group_name(data.item.groupId) }}
                            </div>
                        </template>
                        <template #cell(averageOrderIntervalDays)="data">
                            {{ data.item.averageOrderIntervalDays ? data.item.averageOrderIntervalDays : '-' }}
                        </template>
                        <template #cell(daysNumberSinceLastOrdered)="data">
                            {{
                                data.item.daysNumberSinceLastOrdered == null ? '-' : data.item.daysNumberSinceLastOrdered
                            }}
                        </template>
                        <template #cell(lastName)="data">
                            {{ data.item.lastName ? data.item.lastName : '-' }}
                        </template>
                        <template #cell(firstName)="data">
                            {{ data.item.firstName ? data.item.firstName : '-' }}
                        </template>
                        <template #cell(loyaltyLevel)="data">
                            {{ data.item.loyaltyLevel ? data.item.loyaltyLevel.number : '-' }}
                        </template>
                        <template #cell(totalOrdersAmount)="data">
                            {{ data.item.totalOrdersAmount.toLocaleString('fa-IR') }}
                        </template>
                        <template #cell(totalOrdersCount)="data">
                            {{ data.item.totalOrdersCount.toLocaleString('fa-IR') }}
                        </template>
                        <template #cell(favoriteProductId)="data">
                            {{ findProduct(data.item.favoriteProductId) }}
                        </template>
                        <template #cell(score)="data">
                            {{ data.item.score.toLocaleString('fa-IR') }}
                        </template>
                    </b-table>
                    <div v-else class="text-center pt-5 pb-4">
                        موردی وجود ندارد
                    </div>
                </b-overlay>
            </b-card>
            <b-pagination align="center" @input="getCustomers" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />


            <!------------------------------- modal create customer ------------------------------->
            <b-modal id="create-customer-group" title="ایجاد گروهی مشتری" centered :hide-footer="true"
                title-class="font-weight-bolder" size="sm">
                <div class="p-1">
                    <b-form-group label="آپلود فایل (فرمت مجاز xlsx یا xls)">
                        <div class="d-flex align-items-center position-relative">
                            <b-form-file ref="file" browse-text="بارگذاری" v-model="file" @change="createCustomerGroup"
                                accept=".xlsx, .xls" :disabled="loadingButton" placeholder="" />
                            <div class="position-absolute d-flex align-items-center" style="z-index: 1;left: 85px;">
                                <b-spinner v-if="loadingButton" variant="primary" small></b-spinner>
                            </div>
                        </div>
                    </b-form-group>
                    <div>
                        <b-badge :href="require('@/assets/images/pages/allowed-format-c.png')" target="_blank" pill
                            variant="light-primary">
                            <feather-icon icon="LinkIcon" class="mr-25" />
                            <span>نمونه فرمت صحیح فایل</span>
                        </b-badge>
                    </div>
                    <div class="mt-2">
                        <div v-for="(item, index) in recordsErrors" :key="`recordsErrors${index}`" class="mb-1">
                            <h5 class="text-primary mb-0">{{ `ردیف : ${item.row}` }}</h5>
                            <div class="text-danger">{{ item.message }}</div>
                        </div>
                    </div>
                </div>
            </b-modal>

            <!------------------------------- modal create customer ------------------------------->
            <b-modal id="create-customer" title="ایجاد مشتری" centered :hide-footer="true"
                title-class="font-weight-bolder" size="sm">
                <div class="p-1">
                    <validation-observer ref="createCustomerValidation">
                        <b-form @submit.prevent>

                            <!-- firstName -->
                            <b-form-group label="نام" label-for="firstNameId" class="text-center">
                                <validation-provider #default="{ errors }" name="نام" rules="required">
                                    <b-form-input autocomplete="off" dir="rtl" id="firstNameId" v-model="form.firstName"
                                        name="firstName" class="text-center font-weight-bolder user-select-none"
                                        :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- lastName -->
                            <b-form-group label="نام خانوادگی" label-for="lastNameId" class="text-center">
                                <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                                    <b-form-input autocomplete="off" dir="rtl" id="lastNameId" v-model="form.lastName"
                                        name="lastName" class="text-center font-weight-bolder user-select-none"
                                        :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- phone number -->
                            <b-form-group label="شماره همراه" label-for="phoneNumberId" class="text-center">
                                <validation-provider #default="{ errors }" name="شماره همراه"
                                    rules="phoneNumber|required">
                                    <b-form-input autocomplete="off" dir="ltr" id="phoneNumberId"
                                        v-model="form.phoneNumber" name="phoneNumber"
                                        :state="errors.length > 0 ? false : null"
                                        class="text-center font-weight-bolder user-select-none" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- birthDate -->
                            <div>
                                <b-form-group label="تاریخ تولد" label-for="birthDateId" class="text-center">
                                    <b-form-input id="birthDateId"
                                        class="text-center main-input font-weight-bolder pointer"
                                        :value="form.birthDate ? new Date(form.birthDate).toLocaleDateString('fa-IR') : null"
                                        name="birthDateId" />
                                </b-form-group>
                                <date-picker v-model="form.birthDate" :max="currentDate" format="YYYY-MM-DD"
                                    display-format="jYYYY-jMM-jDD" custom-input="#birthDateId" />
                            </div>


                            <!-- address -->
                            <b-form-group label="آدرس" label-for="addressId" class="text-center">
                                <b-form-textarea id="addressId" v-model="form.address" dir="rtl"
                                    class="text-primary-middle" rows="2" no-resize />
                            </b-form-group>

                            <!-- gender -->
                            <div>
                                <div class="label mb-25 text-center">جنسیت</div>
                                <div class="d-flex align-items-center justify-content-center"
                                    style="width: 100%;height: 2.714rem;">
                                    <div class="d-flex align-items-center">
                                        <b-form-radio v-model="form.gender" name="some-radios" :value="0"
                                            class="custom-control-primary mr-2">
                                            آقا
                                        </b-form-radio>
                                        <b-form-radio v-model="form.gender" name="some-radios" :value="1"
                                            class="custom-control-primary ml-2">
                                            خانم
                                        </b-form-radio>
                                    </div>
                                </div>
                            </div>

                            <b-button type="submit" variant="primary" @click="createCustomer" :disabled="loadingButton"
                                class="w-100 mt-2 d-flex align-items-center justify-content-center">
                                <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                <span>ایجاد</span>
                            </b-button>
                        </b-form>
                    </validation-observer>
                </div>
            </b-modal>

            <!------------------------------- modal customer edit ------------------------------->
            <b-modal id="customer-edit" title="ویرایش اطلاعات مشتری" centered :hide-footer="true"
                title-class="font-weight-bolder" size="md">
                <div class="p-1">
                    <validation-observer ref="editCustomerValidation">
                        <b-form @submit.prevent>

                            <!-- firstName -->
                            <b-form-group label="نام" label-for="firstNameId" class="text-center">
                                <validation-provider #default="{ errors }" name="نام" rules="required">
                                    <b-form-input autocomplete="off" dir="rtl" id="firstNameId"
                                        v-model="customerForm.firstName" name="firstName"
                                        class="text-center font-weight-bolder user-select-none"
                                        :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- lastName -->
                            <b-form-group label="نام خانوادگی" label-for="lastNameId" class="text-center">
                                <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                                    <b-form-input autocomplete="off" dir="rtl" id="lastNameId"
                                        v-model="customerForm.lastName" name="lastName"
                                        class="text-center font-weight-bolder user-select-none"
                                        :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- birthDate -->
                            <div>
                                <b-form-group label="تاریخ تولد" label-for="birthDateId" class="text-center">
                                    <b-form-input id="birthDateId"
                                        class="text-center main-input font-weight-bolder pointer"
                                        :value="customerForm.birthDate ? new Date(customerForm.birthDate).toLocaleDateString('fa-IR') : null"
                                        name="birthDateId" />
                                </b-form-group>
                                <date-picker v-model="customerForm.birthDate" :max="currentDate" format="YYYY-MM-DD"
                                    display-format="jYYYY-jMM-jDD" custom-input="#birthDateId" />
                            </div>

                            <!-- phone number -->
                            <b-form-group label="شماره همراه" label-for="phoneNumberId" class="text-center">
                                <validation-provider #default="{ errors }" name="شماره همراه"
                                    rules="phoneNumber|required">
                                    <b-form-input autocomplete="off" dir="ltr" id="phoneNumberId"
                                        v-model="customerForm.phoneNumber" name="phoneNumber" disabled
                                        :state="errors.length > 0 ? false : null"
                                        class="text-center font-weight-bolder user-select-none" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- address -->
                            <b-form-group label="آدرس" label-for="addressId" class="text-center">
                                <b-form-textarea id="addressId" v-model="customerForm.address" dir="rtl"
                                    class="text-primary-middle" rows="2" no-resize />
                            </b-form-group>

                            <!-- gender -->
                            <div>
                                <div class="label mb-25 text-center">جنسیت</div>
                                <div class="d-flex align-items-center justify-content-center"
                                    style="width: 100%;height: 2.714rem;">
                                    <div class="d-flex align-items-center">
                                        <b-form-radio v-model="customerForm.gender" name="some-radios" :value="0"
                                            class="custom-control-primary mr-2">
                                            آقا
                                        </b-form-radio>
                                        <b-form-radio v-model="customerForm.gender" name="some-radios" :value="1"
                                            class="custom-control-primary ml-2">
                                            خانم
                                        </b-form-radio>
                                    </div>
                                </div>
                            </div>

                            <b-button type="submit" variant="primary" @click="editCustomer" :disabled="loadingButton"
                                class="w-100 mt-2 d-flex align-items-center justify-content-center">
                                <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                <span>ویرایش</span>
                            </b-button>
                        </b-form>
                    </validation-observer>
                </div>
            </b-modal>
        </div>
        <b-card v-else>
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BBadge, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BFormFile, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, phoneNumber } from '@validations';
import vSelect from 'vue-select';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BBadge,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BFormFile,
        vSelect
    },
    mixins: [accessHandling],
    data() {
        return {
            isAdminIdentityVerified: false,
            required,
            phoneNumber,
            loadingPage: true,
            loading: false,
            loadingButton: false,
            customerList: [],
            currentDate: '',
            customerForm: {
                gender: null,
                birthDate: null,
                lastName: null,
                firstName: null,
                phoneNumber: null,
                address: null
            },
            sortByData: [
                { name: 'تاریخ ایجاد', id: 0 },
                { name: 'امتیاز', id: 1 },
                { name: 'اعتبار', id: 2 },
                { name: 'زمان آخرین خرید', id: 3 },
                { name: 'تعداد خرید', id: 4 },
                { name: 'مبلغ خرید', id: 5 },
            ],
            groupIdData: [
                { name: 'همراهِ همیشگی', id: 1 },
                { name: 'همراهِ هفتگی', id: 2 },
                { name: 'همراهِ ماهانه', id: 3 },
                { name: 'لبه‌ی فراموشی', id: 4 },
                { name: 'مشتریان خاموش', id: 5 },
            ],
            sortDescendingData: [
                { name: 'صعودی', id: false },
                { name: 'نزولی', id: true }
            ],
            form: {
                gender: null,
                birthDate: null,
                lastName: null,
                firstName: null,
                phoneNumber: null
            },
            fields: [
                {
                    key: 'number',
                    label: 'شماره اشتراک',
                },
                {
                    key: 'firstName',
                    label: 'نام',
                },
                {
                    key: 'lastName',
                    label: 'نام خانوادگی',
                },
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه',
                },
                {
                    key: 'score',
                    label: 'امتیاز',
                },
                {
                    key: 'walletBalance',
                    label: 'اعتبار (ریال)',
                },
                {
                    key: 'totalOrdersAmount',
                    label: 'مبلغ خرید (ریال)',
                },
                {
                    key: 'totalOrdersCount',
                    label: 'تعداد خرید',
                },
                {
                    key: 'groupId',
                    label: 'وفاداری',
                },
                {
                    key: 'loyaltyLevel',
                    label: 'سطح',
                },
                {
                    key: 'averageOrderIntervalDays',
                    label: 'میانگین فاصله خرید (روز)',
                },
                {
                    key: 'daysNumberSinceLastOrdered',
                    label: 'آخرین خرید (روز)',
                },
                {
                    key: 'favoriteProductId',
                    label: 'محصول مورد علاقه',
                },
                {
                    key: 'customerEdit',
                    label: 'ویرایش',
                },
                {
                    key: 'ordersList',
                    label: 'لیست سفارشات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                phoneNumber: null,
                searchTerm: null,
                sortBy: null,
                levelNumber: null,
                sortDescending: null,
                maxScore: null,
                minScore: null,
                groupId: null,
                maxTotalOrdersCount: null,
                minTotalOrdersCount: null,
                maxTotalOrdersAmount: null,
                minTotalOrdersAmount: null,
                maxDaysNumberSinceLastOrdered: null,
                minDaysNumberSinceLastOrdered: null,
                favoriteProductId: null,
            },
            customerId: null,
            storeId: null,
            file: null,
            recordsErrors: [],
            products: [],
            productNameMap: new Map(),
        }
    },
    computed: {
        customer_group_name() {
            return (groupId) => {
                if (groupId == null) {
                    return '-'
                }
                if (groupId == 1) {
                    return 'همراهِ همیشگی'
                }
                if (groupId == 2) {
                    return 'همراهِ هفتگی'
                }
                if (groupId == 3) {
                    return 'همراهِ ماهانه'
                }
                if (groupId == 4) {
                    return 'لبه‌ی فراموشی'
                }
                if (groupId == 5) {
                    return 'مشتریان خاموش'
                }
            }
        },
        customer_group_color() {
            return (groupId) => {
                if (groupId == null) {
                    return null
                }
                if (groupId == 1) {
                    return '#50E3C2'
                }
                if (groupId == 2) {
                    return '#ffd057'
                }
                if (groupId == 3) {
                    return '#ffb446'
                }
                if (groupId == 4) {
                    return '#4A90E2'
                }
                if (groupId == 5) {
                    return '#847ad9'
                }
            }
        },
    },
    methods: {
        findProduct(productId) {
            return this.productNameMap.get(productId) || '-';
        },
        getAllProducts() {
            storeService.getAllProducts(this.storeId).then(({ data }) => {
                let categories = data.categories
                if (categories.length) {
                    categories.forEach(obj => {
                        obj.products.forEach(product => {
                            this.products.push(product)
                        });
                    });
                }
                this.productNameMap = new Map(this.products.map(p => [p.id, p.name_Fa]));
                this.getCustomers()
            })
        },
        removeFilters() {
            this.parameters.phoneNumber = null;
            this.parameters.searchTerm = null;
            this.parameters.sortBy = null;
            this.parameters.levelNumber = null;
            this.parameters.sortDescending = null;
            this.parameters.maxScore = null;
            this.parameters.minScore = null;
            this.parameters.groupId = null;
            this.parameters.maxTotalOrdersCount = null;
            this.parameters.minTotalOrdersCount = null;
            this.parameters.maxTotalOrdersAmount = null;
            this.parameters.minTotalOrdersAmount = null;
            this.parameters.maxDaysNumberSinceLastOrdered = null;
            this.parameters.minDaysNumberSinceLastOrdered = null;
            this.parameters.favoriteProductId = null;
            this.getCustomers()
        },
        showModalCreateCustomer() {
            this.recordsErrors = []
            this.$bvModal.show('create-customer-group')
        },
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        showModalEdit(item) {
            this.customerId = item.id
            this.customerForm.gender = item.gender
            this.customerForm.birthDate = item.birthDate
            this.customerForm.lastName = item.lastName
            this.customerForm.firstName = item.firstName
            this.customerForm.phoneNumber = item.phoneNumber
            this.customerForm.address = item.address
            this.$bvModal.show('customer-edit')
        },
        createCustomerGroup(event) {
            this.loadingButton = true;
            let file = event.target.files[0];
            let fileExtension = file.name.split('.').pop().toLowerCase();
            if (fileExtension === 'xlsx' || fileExtension === 'xls') {
                let formData = new FormData();
                formData.append("File", file, file.name)
                storeService.customersImportFromExcel(this.storeId, formData).then(({ data }) => {
                    this.recordsErrors = data.recordsErrors
                    this.getCustomers()
                    this.$notif({ type: 'success' });
                })
                    .finally(() => {
                        this.file = null
                        this.loadingButton = false;
                    });
            }
            else {
                this.$refs.file.reset();
                this.$notif({ type: 'normal', title: 'فرمت وارد شده باید xlsx یا xls باشد' });
                this.file = null
                this.loadingButton = false;
            }
        },
        getCustomers() {
            this.loading = true
            storeService.getCustomers(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.customerList = data.items
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.customerList = data.items
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        editCustomer() {
            this.$refs.editCustomerValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true;
                    let data = {
                        gender: this.customerForm.gender,
                        lastName: this.customerForm.lastName,
                        firstName: this.customerForm.firstName,
                        birthDate: this.customerForm.birthDate,
                        address: this.customerForm.address
                    }
                    storeService.editCustomer(this.storeId, this.customerId, data).then(({ data }) => {
                        this.getCustomers()
                        this.loadingButton = false;
                        this.$refs.editCustomerValidation.reset();
                        this.$bvModal.hide('customer-edit')
                        this.$notif({ type: 'success', title: 'ویرایش با موفقیت انجام شد' });
                        this.customerForm.gender = null
                        this.customerForm.firstName = null
                        this.customerForm.lastName = null
                        this.customerForm.birthDate = null
                        this.customerForm.phoneNumber = null
                        this.customerForm.address = null
                    })
                        .catch(() => {
                            this.loadingButton = false;
                        });
                }
            });
        },
        createCustomer() {
            this.$refs.createCustomerValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true;
                    storeService.createCustomer(this.storeId, this.form).then(({ data }) => {
                        this.getCustomers()
                        this.form.gender = null
                        this.form.birthDate = null
                        this.form.lastName = null
                        this.form.firstName = null
                        this.form.phoneNumber = null
                        this.form.address = null
                        this.loadingButton = false;
                        this.$refs.createCustomerValidation.reset();
                        this.$bvModal.hide('create-customer')
                        this.$notif({ type: 'success', title: 'مشتری با موفقیت ایجاد شد' });
                    })
                        .catch(() => {
                            this.loadingButton = false;
                        });
                }
            });
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.getAllProducts()
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const today = new Date();
        this.currentDate = this.formatDate2(today);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>